export default __webpack_public_path__ + "static/media/how-to-be-a-human-being.54008e6d.jpg";